<template>
	<div>
		<el-dialog  :before-close="closediag"  :visible.sync="kgdialog" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" v-dialogDrag>
			<minhead :headtitle="headtitle" :isdiag="true"></minhead>
			<div class="kgall">
				<!--<div>
					<el-table :data="tableDatans" border  style="width: 100%">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column  prop="nasrsbh" label="纳税人识别号" align="center" width="560px"></el-table-column>
					</el-table>
				</div>-->
				<div >
                    <el-radio-group v-model="radio">
                        <el-table :data="tableDatakp" border style="width: 680px">
                            <el-table-column    label="序号">
                                <template slot-scope="scope">
                                    <el-radio  :label="scope.$index+1 " @change="radiochange(scope.row)"></el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column  prop="kaipjbh" label="开票机号" align="center"></el-table-column>
                            <el-table-column  prop="kaipjmc" label="开票机名称" align="center" ></el-table-column>
                            <el-table-column  prop="mainNo" label="主/分盘号" align="center" ></el-table-column>
                        </el-table>
                    </el-radio-group>
				</div>
				<div class="buttomanniu">
					<div @click="openInvoice">确定</div>
					<div @click="closediag">关闭</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script> 
	export default {
		props: {
			kgdialog: {
			    type: Boolean, //指定传入的类型
			    //type 也可以是一个自定义构造器函数，使用 instanceof 检测。
			},
		    headtitle: {
		        type: Array, //指定传入的类型
		        //type 也可以是一个自定义构造器函数，使用 instanceof 检测。
		    },
			tableDatans: {
			    type: Array, //指定传入的类型
			    //type 也可以是一个自定义构造器函数，使用 instanceof 检测。
			},
			tableDatakp: {
			    type: Array, //指定传入的类型
			    //type 也可以是一个自定义构造器函数，使用 instanceof 检测。
			}
		},
		watch: {
			kgdialog: function(indexVal, oldVal) {
				if(indexVal){
					console.log(this.tableDatakp)
					this.tableDatakp.forEach((item,index)=>{
						if(item.queskpj =="1"){
							this.radio=parseFloat(index)+1
							 this.$emit('radiochange', item);
						}
					})
				}
				},
				},
	    components:{
	    },
	    data() {
	        return {
                radio:''
	        };
	    },
	    created(){
		
	    },
	    methods: {
            radiochange(row){
                this.$emit('radiochange', row);

            },
            closediag(){
                 this.radio='';
                 this.$emit('closekgdialog', false);
            },
            openInvoice()
            {
                this.$emit('openInvoice');
            }
	    },
	};
</script>

<style  scoped="scoped" lang="less">
	// /deep/.el-dialog__body {
	// 	padding: 0 !important;
	// }
	
	.kgall/deep/.el-table thead{
			font-size: 15px;
			font-weight: bold;
			color: #0080FF;
	
		}
		.kgall/deep/.el-table th {
		    background-color: white !important;
		}
		.kgall:extend(.Verticalcenter){
			
		}
		.kgall/deep/.el-table--small td {
			padding: 7px 0;
		}
		.kgall/deep/.el-table__body-wrapper {
			min-height: 0px;
		}
		.kgall>div:nth-of-type(1){
			margin-top: 45px;
		}
		.kgall>div:nth-of-type(2){
			margin-top: 45px;
		}
		
		.kgall/deep/.el-table--border, .el-table--group {
	    border: 1px solid #D2D2D2;
		  border-bottom: 0.1px solid #D2D2D2;
		  border-right:0.1px solid #D2D2D2;
	}
		.kgall/deep/.el-table--border td{
			    border-right: 1px solid #D2D2D2;
		}
		.kgall/deep/.el-table td{
			  border-bottom: 1px solid #D2D2D2;
		}
		.kgall/deep/.el-table th.is-leaf {
		    border-bottom: 1px solid #D2D2D2;
		}
		.kgall/deep/.el-table--border th {
		    border-right: 1px solid #D2D2D2;
		}
</style>
